import React from 'react';
import {
    BodyLargeRegular,
    Button,
    CrossIcon,
    DisplayExtraSmall,
    ModalHeader,
    ProductButton,
    ProductImage
} from 'prospect-path-base';

import { connect } from 'react-redux';
import createProductForTeam from '../../../actions/product-management/CreateProductForTeam';

class ShowExistingProducts extends React.Component {
  render() {
    const teamProductIds = this.props.teamProducts.map(product => product.id);
    const availableProducts = this.props.vendorProducts.filter(product => !teamProductIds.includes(product.id));

    return (
      <div>
        <ModalHeader
          title={(
            <div>
              <DisplayExtraSmall>Add a product</DisplayExtraSmall>
              <BodyLargeRegular>We found some existing products from your company</BodyLargeRegular>
            </div>
          )}
          close={<CrossIcon onClick={this.props.closeProductModal} />}
        />

        <div style={{ marginBottom: '1.5rem' }}>
          {availableProducts
            .map(product => (
              <ProductButton
                image={<ProductImage src={product.clearbit_logo} />}
                title={<BodyLargeRegular as="span">{product.name}</BodyLargeRegular>}
                onClick={() => this.props.setStep('EditExistingProduct', product)}
              />
            ))
          }
          <Button
            block
            onClick={() => this.props.setStep('NewProductIfHasProducts')}
          >
            Create new product
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  vendorProducts: state.productManagement.vendorProducts,
  teamProducts: state.productManagement.products.all,
});

const mapDispatchToProps = dispatch => ({
  createProductForTeam: (teamId, productData) => dispatch(createProductForTeam(teamId, productData))
});

export default connect(mapStateToProps, mapDispatchToProps)(ShowExistingProducts);
